import { render, staticRenderFns } from "./CreateProducts.vue?vue&type=template&id=88e4ff6c&"
import script from "./CreateProducts.vue?vue&type=script&lang=js&"
export * from "./CreateProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports